import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyGlobalAnnouncementsQueryVariables = Types.Exact<{
  myRoles: Array<Types.Scalars['String']> | Types.Scalars['String'];
}>;


export type GetMyGlobalAnnouncementsQuery = { __typename?: 'Query', myGlobalAnnouncements: Array<{ __typename: 'GlobalAnnouncement', id: string, name: string, content: string, roles: Array<string>, activated: boolean, emailNotification: boolean, createdAt?: any | null, startDate?: any | null, endDate?: any | null, createdBy: { __typename?: 'User', id: string, name: string }, modifiedBy: { __typename?: 'User', id: string, name: string } }> };

export type MarkAsReadGlobalAnnouncementMutationVariables = Types.Exact<{
  input: Types.MarkAsReadGlobalAnnouncementInput;
}>;


export type MarkAsReadGlobalAnnouncementMutation = { __typename?: 'Mutation', markAsReadGlobalAnnouncement: { __typename?: 'MarkAsReadGlobalAnnouncementPayload', boolean?: boolean | null } };


export const GetMyGlobalAnnouncementsDocument = gql`
    query GetMyGlobalAnnouncements($myRoles: [String!]!) {
  myGlobalAnnouncements(myRoles: $myRoles) {
    id
    name
    content
    roles
    activated
    emailNotification
    createdBy {
      id
      name
    }
    modifiedBy {
      id
      name
    }
    createdAt
    startDate
    endDate
    __typename
  }
}
    `;

/**
 * __useGetMyGlobalAnnouncementsQuery__
 *
 * To run a query within a React component, call `useGetMyGlobalAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyGlobalAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyGlobalAnnouncementsQuery({
 *   variables: {
 *      myRoles: // value for 'myRoles'
 *   },
 * });
 */
export function useGetMyGlobalAnnouncementsQuery(baseOptions: Apollo.QueryHookOptions<GetMyGlobalAnnouncementsQuery, GetMyGlobalAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyGlobalAnnouncementsQuery, GetMyGlobalAnnouncementsQueryVariables>(GetMyGlobalAnnouncementsDocument, options);
      }
export function useGetMyGlobalAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyGlobalAnnouncementsQuery, GetMyGlobalAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyGlobalAnnouncementsQuery, GetMyGlobalAnnouncementsQueryVariables>(GetMyGlobalAnnouncementsDocument, options);
        }
export type GetMyGlobalAnnouncementsQueryHookResult = ReturnType<typeof useGetMyGlobalAnnouncementsQuery>;
export type GetMyGlobalAnnouncementsLazyQueryHookResult = ReturnType<typeof useGetMyGlobalAnnouncementsLazyQuery>;
export type GetMyGlobalAnnouncementsQueryResult = Apollo.QueryResult<GetMyGlobalAnnouncementsQuery, GetMyGlobalAnnouncementsQueryVariables>;
export const MarkAsReadGlobalAnnouncementDocument = gql`
    mutation MarkAsReadGlobalAnnouncement($input: MarkAsReadGlobalAnnouncementInput!) {
  markAsReadGlobalAnnouncement(input: $input) {
    boolean
  }
}
    `;
export type MarkAsReadGlobalAnnouncementMutationFn = Apollo.MutationFunction<MarkAsReadGlobalAnnouncementMutation, MarkAsReadGlobalAnnouncementMutationVariables>;

/**
 * __useMarkAsReadGlobalAnnouncementMutation__
 *
 * To run a mutation, you first call `useMarkAsReadGlobalAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAsReadGlobalAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAsReadGlobalAnnouncementMutation, { data, loading, error }] = useMarkAsReadGlobalAnnouncementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkAsReadGlobalAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<MarkAsReadGlobalAnnouncementMutation, MarkAsReadGlobalAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAsReadGlobalAnnouncementMutation, MarkAsReadGlobalAnnouncementMutationVariables>(MarkAsReadGlobalAnnouncementDocument, options);
      }
export type MarkAsReadGlobalAnnouncementMutationHookResult = ReturnType<typeof useMarkAsReadGlobalAnnouncementMutation>;
export type MarkAsReadGlobalAnnouncementMutationResult = Apollo.MutationResult<MarkAsReadGlobalAnnouncementMutation>;
export type MarkAsReadGlobalAnnouncementMutationOptions = Apollo.BaseMutationOptions<MarkAsReadGlobalAnnouncementMutation, MarkAsReadGlobalAnnouncementMutationVariables>;